import { useMemo } from "react";
import Storage from "../services/storage.service";

const useIsInAppFlow = () => {
  return useMemo(() => {
    try {
      const inAppFlow = Storage.get("inAppFlow", true);
      return inAppFlow ? JSON.parse(inAppFlow) : false;
    } catch (e) {
      return false;
    }
  }, []);
};

export default useIsInAppFlow;
